import { PageContainer } from "~/components/pageContainer/PageContainer";
import { LegacyCard } from "~/components/card/LegacyCard";
import { Button } from "@sellar-io/components";
import { ReactElement } from "react";
import { useNavigate } from "react-router";
import { NavigationBar } from "~/components/navigation/NavigationBar";
import * as ROUTES from "../../constants/routes";
import { BUSINESS } from "~/constants/routes";
import { BusinessFormCreate } from "~/forms/business/BusinessFormCreate";
import { useSellarUser } from "~/hooks";

export function SupplierCreatePage(): ReactElement {
  const navigate = useNavigate();

  const { changeBusiness } = useSellarUser();

  return (
    <>
      <NavigationBar
        title={"Create supplier"}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => navigate(BUSINESS)}
      />
      <PageContainer>
        <LegacyCard>
          <BusinessFormCreate
            mode="business"
            type={"supplier"}
            formId="create-supplier-form"
            onCreate={(business) => {
              changeBusiness(business.id);
              navigate(ROUTES.ORDERS);
            }}
          />
          <div className="mt-4">
            <Button type="submit" form="create-supplier-form">
              Save
            </Button>
          </div>
        </LegacyCard>
      </PageContainer>
    </>
  );
}
